module.exports = __webpack_public_path__ + "static/media/sketch5.0e3e9544.jpg";